module.exports = __webpack_public_path__ + "static/media/jc-logo.798b6f41.png";